<template>
<div class="paper">
  <modal-form modal-id="add-writer" animation="fadeInRight">
      <div slot="title">Add New Writer</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg">
              <div class="col-lg-4">Name</div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="addWriter['name']">
              </div>
              <br />
              <div class="col-lg-4">Email</div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="addWriter['email']">
              </div>
              <br />
              <div class="col-lg-4">Bank Details</div>
              <div class="col-lg-8">
                <textarea type="text" name="" class="form-control" v-model="addWriter['bank']" rows="5" />
              </div>
              <br />
              <div class="col-lg-4">Price</div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="addWriter['price']">
              </div>
            </div>
          </div>
          <div class="row m-t-md">
            <div class="col-lg-12">
              <button class="btn btn-sm btn-primary" @click="createWriter" data-toggle="modal" data-target="#add-writer">Save</button>
            </div>
          </div>
        </div>
      </div>
    </modal-form>
    <div class="ibox-title">
    <h5>Writers</h5>
      <div class="pull-right">
        <button class="btn btn-xs btn-primary mx-2" data-toggle="modal" data-target="#add-writer">Add Writer</button>
      </div>
    </div>
    <div  style="padding:20px">
    <table class="table table-dark">
    <thead>
    <tr>
        <th>Name</th>
        <th>Email</th>
        <th>Bank Details</th>
        <th>Price in Eur</th>
        <th>Pending Payment Orders</th>
        <th>Pending Invoice Orders</th>
        <th>Actions</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="writer in writers" :key="writer.id">
        <td><input :value="writer.name" @change="(e)=>updateWriter({id:'name', val:e.target.value}, writer)" /></td>
        <td><input :value="writer.email" @change="(e)=>updateWriter({id:'email', val:e.target.value}, writer)" /></td>
        <td><textarea :value="writer.bank" @change="(e)=>updateWriter({id:'bank', val:e.target.value}, writer)" /></td>
        <td><input :value="writer.price" @change="(e)=>updateWriter({id:'price', val:e.target.value}, writer)" /></td>
        <td>{{ writer.pendingPayment }}</td>
        <td>{{ writer.pendingInvoice }}</td>
        <td>
        <button class="btn btn-xs btn-danger mx-2" @click="()=>deleteWriter(writer.id)">Delete</button></td>
    </tr>
    </tbody>
    </table>
  </div>
    <hr />
    <div class="pagination">
      <div>
        <span><strong>Records: </strong>{{ totalPages }}</span>
      </div>
      <div>
        <button @click="prevPage" :disabled="page === 1">Previous</button>
        <span>&nbsp;{{ page }} / {{ Math.ceil(totalPages/perPage) }}&nbsp;</span>
        <button @click="nextPage" :disabled="page >= totalPages/perPage">Next</button>
      </div>
      <div>
        <strong for="pageSize">Rows:&nbsp;</strong>
        <select id="pageSize" v-model="perPage" @change="changePageSize">
          <option v-for="size in pageSizes" :value="size" :key="size">{{ size }}</option>
        </select>
      </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import Modal from '@/components/Helpers/Modal/Form'

// Add Inventory Defaults
const addDefaultWriter = {
  name: '',
  email: '',
  bank: ''
}

export default {
  data () {
    return {
      sort: {field: '0', direction: '1'},
      writers: [],
      addWriter: {...addDefaultWriter},
      page: 1,
      perPage: 10,
      totalPages: 0,
      pageSizes: [10, 25, 50]
    }
  },
  async mounted () {
    this.getWriters()
  },
  components: {
    modalForm: Modal
  },
  methods: {
    async deleteWriter (id) {
      await axios.delete(`/v2/instalinko/writers/${id}`)
      this.getWriters()
      this.$toastr.success('Writer deleted successfully', 'Brilliant stuff lad')
    },
    async createWriter () {
      const addWriter = {...this.addWriter}
      try {
        await axios.post('/v2/instalinko/writers', addWriter)
        this.getWriters()
        this.$toastr.success('Writer added successfully', 'Brilliant stuff lad')
      } catch (err) {
        console.log(err)
      }
    },
    async updateWriter (item, writer) {
      try {
        const res = await axios.patch(`/v2/instalinko/writers/${writer.id}`, {[item.id]: item.val})
        console.log(res)
      } catch (err) {
        console.log(err)
      }
    },
    changePageSize () {
      this.page = 1 // reset the page to the first page when changing the page size
      this.getWriters()
    },
    async getWriters () {
      try {
        const res = await axios.get(`/v2/instalinko/writers`, {
          params: {
            filter: {},
            options: {
              page: this.page,
              perPage: this.perPage,
              sort: this.sort.field !== '0' ? {
                [this.sort.field]: Number(this.sort.direction)
              } : {}
            }
          }
        })
        this.writers = res.data
        this.totalPages = Number(res.headers['x-total-records'])
      } catch (err) {
        console.log(err)
        this.$toastr.error(err, 'Unable to get inventory')
      }
    },
    nextPage () {
      if (this.page < this.totalPages) {
        this.page++
        this.getInventory()
      }
    },
    prevPage () {
      if (this.page > 1) {
        this.page--
        this.getInventory()
      }
    }
  }
}
</script>
<style>
.paper{
background: #fff;
margin-top: 10px;
}
.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pagination>div {
  flex: 1;
  padding: 10px;
  display: flex; /* Enable vertical alignment */
  align-items: center;
}

.pagination>div:nth-child(2) {
  justify-content: center;
}

.pagination>div:nth-child(3) {
  justify-content: flex-end;
}

</style>



// WEBPACK FOOTER //
// src/components/Pages/Instalinko/Writers.vue